export default __webpack_public_path__ + "static/media/instagram-icon.620bb34c.svg";